import { Print, SummarizeTwoTone } from "@mui/icons-material";
import { FC, useMemo, useRef } from "react";
import { CSVLink } from "react-csv";
import { useTranslation } from "react-i18next";
import { useReactToPrint } from "react-to-print";
import useEvent from "react-use-event-hook";
import { useSetRecoilState } from "recoil";

import { AccessControl, MuiButton } from "@ryde/controls";
import { LayoutRight, LayoutRightCrudContentStatic } from "@ryde/layout";
import { usePageContext, useTranslatedLists } from "@ryde/redux";
import {
  ActionsEnum,
  Log,
  PLURAL_KEY,
  reportsOperationsDrawerAtom,
} from "@ryde/shared";

import { ReportOperationsDrawerWrapperStyled } from "./report-operations.drawer.styled";

export const ReportOperationsDrawer: FC = () => {
  const { t } = useTranslation();
  const { ridesCSVHeadersTranslated } = useTranslatedLists();
  const setReportColumnsLayoutDrawerOpened = useSetRecoilState(
    reportsOperationsDrawerAtom,
  );

  const { entity } = usePageContext();

  const printComponentRef = useRef<HTMLDivElement | null>(null);
  const handlePrint = useReactToPrint({
    contentRef: printComponentRef,
    preserveAfterPrint: false,
  });

  const handleExportClick = useEvent(() => {
    Log.debug("Export report");
  });

  const statDataTranslated = useMemo(() => {
    return [];
  }, []);

  return (
    <LayoutRight
      headerTitle={t(`general.BULK_ACTIONS`)}
      showFooter={false}
      closeClick={() => setReportColumnsLayoutDrawerOpened?.(false)}
      showBackgroundImage={false}
      entity={entity}
    >
      <LayoutRightCrudContentStatic>
        <AccessControl entity="system" action={ActionsEnum.AllowExport}>
          <ReportOperationsDrawerWrapperStyled>
            <MuiButton
              muiVariant="text"
              muiSize="small"
              muiStyle="info"
              onClick={() => handlePrint()}
            >
              {t("general.PRINT_EXPORT_REPORTS")}
              <Print color="primary" />
            </MuiButton>
            <MuiButton
              muiVariant="text"
              muiSize="small"
              muiStyle="info"
              onClick={handleExportClick}
            >
              {t("general.PRINT_EXPORT_REPORTS")}
              <SummarizeTwoTone color="primary" />
            </MuiButton>
            <CSVLink
              data={statDataTranslated}
              headers={ridesCSVHeadersTranslated}
              filename={`${t(`report.${PLURAL_KEY}`)}.csv`}
              style={{ display: "flex", flexDirection: "column" }}
            >
              <MuiButton
                muiVariant="text"
                muiSize="small"
                muiStyle="info"
                onClick={() => null}
              >
                {t(`general.EXPORT_CSV`)}
              </MuiButton>
            </CSVLink>
          </ReportOperationsDrawerWrapperStyled>
        </AccessControl>
        <div style={{ display: "none" }}>
          {/* <BulkPrintReports ref={printComponentRef} /> */}
        </div>
      </LayoutRightCrudContentStatic>
    </LayoutRight>
  );
};
